/**
 * Slash Commands Location Cleanup Hook
 * 
 * Location değiştiğinde slash command UI state'ini temizler
 * Menu açık kalmaması için
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSlashCommandStore } from '../store/slash-command-store';

/**
 * Location değiştiğinde slash command menu'yu kapat
 * 
 * Bu hook'u App.tsx veya MainLayout'a ekle
 */
export const useSlashCommandsLocationCleanup = () => {
  const location = useLocation();
  const { resetUIState } = useSlashCommandStore();
  
  useEffect(() => {
    // Location değiştiğinde UI state'i temizle
    resetUIState();
  }, [location.pathname, resetUIState]);
};

